import React from 'react';
import './Contact.css';
import StoreButtons from '../../components/StoreButtons';
import useContactForm from '../../hooks/useContactForm';

const Contact = () => {
  const { formData, submitted, setSubmitted, loading, error, handleChange, handleSubmit } = useContactForm(
    { email: '', message: '' },
    { resetAfterMs: 5000 },
  );

  return (
    <div className="contact-page">
      <div
        className="contact-header"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/horizontal_background.png)`
        }}
      >
        <div className="container">
          <div className="header-text-container">
            <h1>Contact Us</h1>
            <p>We'd love to hear from you. Get in touch with us!</p>
          </div>
        </div>
      </div>

      <div className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Information */}
            <div className="contact-info-section">
              <h2>Get In Touch</h2>
              <p className="contact-intro">
                Have a question, feedback, or need support? We're here to help!
                Reach out to us through any of the following channels.
              </p>

              <div className="contact-cards">
                <div className="contact-card">
                  <div className="contact-icon">📱</div>
                  <h3>Download App</h3>
                  <p className="contact-card-desc">Available on Android & iOS</p>
                  <StoreButtons />
                </div>

                <div className="contact-card">
                  <div className="contact-icon">✨</div>
                  <h3>How It Works</h3>
                  <p className="contact-card-desc">See the simple steps to start ordering</p>
                  <a href="/#how-it-works" className="btn-learn-more">
                    Explore Features
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </a>
                </div>
              </div>

              <div className="contact-info-text">
                <p>
                  Have questions or feedback? Use the contact form to send us a message,
                  and we'll get back to you as soon as possible.
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div
              className="contact-form-section"
              style={{
                backgroundImage: `linear-gradient(135deg, rgba(102, 126, 234, 0.03) 0%, rgba(118, 75, 162, 0.03) 100%), url(${process.env.PUBLIC_URL}/images/horizontal_background.png)`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
              }}
            >
              <h2>Send Us a Message</h2>

              {submitted ? (
                <div className="success-message">
                  <div className="success-icon">✓</div>
                  <h3>Message Sent Successfully!</h3>
                  <p>
                    Thank you for reaching out to us. Your message has been received
                    and our team will get back to you as soon as possible.
                  </p>
                  <button
                    onClick={() => setSubmitted(false)}
                    className="btn btn-back"
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (
                <>
                  {error && (
                    <div className="error-message">
                      <div className="error-icon">⚠️</div>
                      <p>{error}</p>
                    </div>
                  )}

                  <form onSubmit={(e) => handleSubmit(e, { email: formData.email, message: formData.message })} className="contact-form">
                    <div className="form-group">
                      <label htmlFor="email">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="your.email@example.com"
                        disabled={loading}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="message">Message *</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        rows="8"
                        placeholder="Tell us what's on your mind..."
                        disabled={loading}
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn btn-submit"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span className="spinner"></span>
                          Sending...
                        </>
                      ) : (
                        'Send Message'
                      )}
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;

